"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warning = exports.success = exports.disabled = exports.alert = void 0;
var _styledComponents = require("styled-components");
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
// TODO: fix more variants and utilise theme for colors
var success = (0, _styledComponents.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n"], ["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.white;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.pill.success;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.pill.success;
});
exports.success = success;
var alert = (0, _styledComponents.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n"], ["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.white;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.pill.alert;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.pill.alert;
});
exports.alert = alert;
var warning = (0, _styledComponents.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n"], ["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.grey[0];
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.pill.warning;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.pill.warning;
});
exports.warning = warning;
var disabled = (0, _styledComponents.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n"], ["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.grey[2];
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.pill.disabled;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.pill.disabled;
});
exports.disabled = disabled;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;